module.exports = __webpack_public_path__ + "static/media/f.b76f395e.png";